import React, { memo } from 'react'

interface CaseIconProps {
  size?: number
  className?: string
}

const CaseIcon: React.FC<CaseIconProps> = memo(({ size = 27, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 27 28"
    fill="none"
    className={className || ''}
  >
    <path
      d="M23.3136 6.46487H18.9996V5.60207C18.9996 4.91558 18.7269 4.25722 18.2415 3.7718C17.7561 3.28638 17.0977 3.01367 16.4112 3.01367H11.2344C10.548 3.01367 9.88959 3.28638 9.40417 3.7718C8.91875 4.25722 8.64604 4.91558 8.64604 5.60207V6.46487H4.33204C3.87439 6.46487 3.43547 6.64667 3.11186 6.97029C2.78825 7.2939 2.60645 7.73281 2.60645 8.19047V21.9953C2.60645 22.4529 2.78825 22.8918 3.11186 23.2154C3.43547 23.5391 3.87439 23.7209 4.33204 23.7209H23.3136C23.7713 23.7209 24.2102 23.5391 24.5338 23.2154C24.8574 22.8918 25.0392 22.4529 25.0392 21.9953V8.19047C25.0392 7.73281 24.8574 7.2939 24.5338 6.97029C24.2102 6.64667 23.7713 6.46487 23.3136 6.46487ZM10.3716 5.60207C10.3716 5.37324 10.4625 5.15379 10.6243 4.99198C10.7862 4.83017 11.0056 4.73927 11.2344 4.73927H16.4112C16.6401 4.73927 16.8595 4.83017 17.0213 4.99198C17.1831 5.15379 17.274 5.37324 17.274 5.60207V6.46487H10.3716V5.60207ZM23.3136 8.19047V12.6781C20.4014 14.2633 17.1385 15.0935 13.8228 15.0929C10.5073 15.0935 7.24445 14.2637 4.33204 12.6792V8.19047H23.3136ZM23.3136 21.9953H4.33204V14.6226C7.28705 16.068 10.5333 16.8191 13.8228 16.8185C17.1125 16.8185 20.3586 16.0671 23.3136 14.6216V21.9953ZM11.2344 12.5045C11.2344 12.2756 11.3253 12.0562 11.4871 11.8944C11.649 11.7326 11.8684 11.6417 12.0972 11.6417H15.5484C15.7773 11.6417 15.9967 11.7326 16.1585 11.8944C16.3203 12.0562 16.4112 12.2756 16.4112 12.5045C16.4112 12.7333 16.3203 12.9528 16.1585 13.1146C15.9967 13.2764 15.7773 13.3673 15.5484 13.3673H12.0972C11.8684 13.3673 11.649 13.2764 11.4871 13.1146C11.3253 12.9528 11.2344 12.7333 11.2344 12.5045Z"
      fill="currentColor"
    />
  </svg>
))

export { CaseIcon }
